import { Inject, Injectable } from '@angular/core';
import { ConfigModel, ENDPOINTS, OdataConfigInterface, ODataConfigModel, OnlineOnlyService } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class OdataConfigService implements OdataConfigInterface {
    public constructor(
        private readonly onlineOnlyService: OnlineOnlyService,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
    ) {}

    public getConfig(): Observable<ConfigModel[]> {
        return this.onlineOnlyService.get(ENDPOINTS.ConfigSet).pipe(
            map((data: ODataConfigModel[]) => data.map((c) => ConfigModel.fromOData(c))),
            catchError((error) => {
                this.log.debug(
                    `OdataConfigService: getConfig: Could not retrieve the ConfigSet with error '${JSON.stringify(
                        error,
                        Object.getOwnPropertyNames(error),
                    )}'`,
                );
                // TODO check if the return type is right
                return of([]);
            }),
        );
    }
}
